export default __webpack_public_path__ + "40a19db51217a578e1a58a985f31a15b.svg";